import {
  LegendColor,
  LegendItem,
  LegendLabel,
  LegendList,
  LegendValue,
} from "./Chart.styles";
import type { ChartLegendSize } from "./Chart.styles";

export interface ChartLegendItem {
  id: string;
  label: string;
  color: string;
  value: string;
}

interface ChartLegendProps {
  items: ChartLegendItem[];
  ariaLabel: string;
  size?: ChartLegendSize;
}

export const ChartLegend = ({
  items,
  ariaLabel,
  size = "sm",
}: ChartLegendProps) => (
  <LegendList aria-label={ariaLabel} $size={size}>
    {items.map((item) => (
      <LegendItem key={item.id} $size={size}>
        <LegendColor $color={item.color} aria-hidden="true" />
        <LegendLabel>{item.label}</LegendLabel>
        <LegendValue>{item.value}</LegendValue>
      </LegendItem>
    ))}
  </LegendList>
);
